export default function SamplesAvailableIcon(props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.2513 4.35459L15.3804 5.86306L14.6262 5.4276L8.52977 15.9869C7.56741 17.6538 5.43786 18.2244 3.77099 17.262C2.10413 16.2997 1.53352 14.1701 2.49588 12.5032L8.5923 1.94393L7.83807 1.50847L8.70898 0L16.2513 4.35459ZM7.57344 12.4178C7.1571 12.1775 6.62412 12.3203 6.38375 12.7366C6.14337 13.1529 6.28619 13.6859 6.70252 13.9263C7.11886 14.1667 7.65185 14.0239 7.89222 13.6075C8.13259 13.1912 7.98978 12.6582 7.57344 12.4178ZM7.37134 9.2842C6.95501 9.04383 6.42202 9.18664 6.18165 9.60298C5.94128 10.0193 6.08409 10.5523 6.50043 10.7927C6.91676 11.033 7.44975 10.8902 7.69012 10.4739C7.93049 10.0576 7.78768 9.52457 7.37134 9.2842ZM13.1177 4.55668L10.1008 2.81485L8.35894 5.8318L11.3759 7.57363L13.1177 4.55668Z"
								fill="currentColor"

			/>
			<path d="M15.3335 14.3328L18.666 11L20 12.3331L15.3335 17L12 13.6662L13.334 12.3331L15.3335 14.3328Z" 				fill="currentColor"
 />
		</svg>
	);
}
